import React, { useRef, useState } from "react";
import axios from "axios";
import Alerts from "../util/Alerts";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import ReactTable from "react-table";
import moment from "moment";
import { routes } from "../gen/General";
import { TIPO_LOGS } from "./utils";
import Datetime from "react-datetime";

export const ListLogs = () => {
    const alert = useRef();
    const [data, setData] = useState({ list: [], pages: 0, loading: false, number: 0, size: 0, total: 0 });
    const [estadistica, setEstadistica] = useState({ remote: 0, no_remote: 0 });
    const [query, setQuery] = useState({
        tipo: 0,
        consulta: "",
        desde: new Date(),
        hasta: new Date(),
        page: 0,
        pageSize: 10,
        sorted: [],
        filtered: [],
    });

    const getData = values => {
        setData({ ...data, loading: true });
        axios.post(routes.api + "/logs", values).then(res => {
            setData({
                list: res.data.content,
                pages: res.data.totalPages,
                loading: false,
                number: res.data.number,
                size: res.data.size,
                total: res.data.totalElements,
            });
        });
        getEstadisticas(values);
    };
    const getEstadisticas = values => {
        axios
            .post(routes.api + "/logs/estadisticas", values)
            .then(res => {
                setEstadistica({ remote: res?.data?.remote ?? 0, no_remote: res?.data?.no_remote ?? 0 });
            })
            .catch(e => console.error(e));
    };
    const findLabel = () => {
        let tp = TIPO_LOGS.find(x => Number(x.value) === Number(query.tipo));
        return tp?.buscar ?? "cédula/placa/RUC";
    };
    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card>
                <CardHeader>
                    <div className={"container-fluid"}>
                        <CardTitle tag={"h4"}>Auditoría Consultas</CardTitle>
                        <br />
                        <div className={"row"}>
                            <div className="col-lg-3">
                                <label>{"Desde"}</label>
                                <Fechas name={"desde"} getData={getData} query={query} setQuery={setQuery} />
                            </div>
                            <div className="col-lg-3">
                                <label>{"Hasta"}</label>
                                <Fechas name={"hasta"} getData={getData} query={query} setQuery={setQuery} />
                            </div>

                            <div className="col-lg-3">
                                <label>{"Tipo"}</label>
                                <select
                                    value={query.tipo}
                                    className="form-control primary"
                                    onChange={e => {
                                        setQuery({ ...query, tipo: e.target.value });
                                        getData({ ...query, tipo: e.target.value });
                                    }}
                                >
                                    <option value={0}>{"TODOS"}</option>
                                    {TIPO_LOGS.map(a => (
                                        <option key={a.value} value={a.value}>
                                            {a.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-3">
                                <label>{"Buscar por " + findLabel()}</label>
                                <input
                                    value={query.consulta}
                                    placeholder={"Ingrese " + findLabel() + "..."}
                                    className="form-control primary"
                                    onChange={e => {
                                        setQuery({ ...query, consulta: e.target.value });
                                        getData({ ...query, consulta: e.target.value });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </CardHeader>
                <br />
                <br />
                <CardBody>
                    <div className={"container-fluid"}>
                        <div className={"row"}>
                            <div className={"col-md-12"}>
                                <h5 className={"text-primary"}>Total Registros: {data.total}</h5>
                                <br />
                                <h5 className={"text-primary"}>Consultas remotas: {estadistica.remote}</h5>
                                <br />
                                <h5 className={"text-primary"}>Consultas no remotas: {estadistica.no_remote}</h5>
                                <br />
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"col-md-12"}>
                                <ReactTable
                                    noDataText={"No hay datos..."}
                                    loadingText={"Cargando..."}
                                    rowsText={"filas"}
                                    ofText={"de"}
                                    previousText={"Anterior"}
                                    nextText={"Siguiente"}
                                    pageText={"Página"}
                                    columns={[
                                        {
                                            Header: "",
                                            accessor: "id",
                                            Cell: row => {
                                                return <div>{data.number * data.size + (row.index + 1)}</div>;
                                            },
                                            width: 60,
                                            filterable: false,
                                            sortable: false,
                                        },
                                        {
                                            Header: "IP",
                                            accessor: "ip",
                                            filterable: false,
                                        },
                                        {
                                            Header: "Usuario",
                                            accessor: "usuario",
                                            filterable: false,
                                        },
                                        {
                                            Header: "Dato consultado",
                                            accessor: "consulta",
                                            filterable: false,
                                            Cell: row => <ViewTipo row={row.original} />,
                                        },
                                        {
                                            Header: "Tipo",
                                            accessor: "tipo",
                                            filterable: false,
                                            Cell: row => {
                                                return <span>{TIPO_LOGS.find(x => x.value === row.value)?.label}</span>;
                                            },
                                        },
                                        {
                                            Header: "Consulta Remota",
                                            accessor: "remote",
                                            filterable: false,
                                            Cell: row => {
                                                return <span>{row.value ? "SI" : "NO"}</span>;
                                            },
                                        },
                                        {
                                            Header: "Fecha de Consulta",
                                            accessor: "localDateTime",
                                            filterable: false,
                                            Cell: row => {
                                                return <span>{moment(row.value).format("DD/MM/YYYY")}</span>;
                                            },
                                        },
                                    ]}
                                    manual
                                    page={data.number || 0}
                                    pages={data.pages}
                                    defaultPageSize={10}
                                    data={data.list}
                                    loading={data.loading}
                                    onFetchData={state => {
                                        setData({ ...data, loading: true });
                                        axios
                                            .post(routes.api + "/logs", {
                                                ...query,
                                                page: state.page,
                                                pageSize: state.pageSize,
                                                sorted: state.sorted,
                                                filtered: state.filtered,
                                            })
                                            .then(res => {
                                                setData({
                                                    list: res.data.content,
                                                    pages: res.data.totalPages,
                                                    loading: false,
                                                    number: res.data.number,
                                                    size: res.data.size,
                                                    total: res.data.totalElements,
                                                });
                                            });
                                        getEstadisticas(query);
                                    }}
                                    filterable
                                    className="-striped -highlight"
                                ></ReactTable>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export const ViewTipo = ({ row }) => {
    const searchDt = tipo => {
        switch (tipo) {
            case 1:
                return row?.placa;
            case 2:
                return row?.cedula;
            case 3:
                return row?.ruc;
            default:
                return "";
        }
    };

    return <span>{searchDt(row.tipo)}</span>;
};

export const Fechas = ({ query, setQuery, getData, name }) => {
    return (
        <Datetime
            className={""}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={false}
            value={query[name] ? moment(query[name]).format("DD/MM/YYYY") : ""}
            onChange={e => {
                if (e instanceof Object) {
                    let date = moment(
                        e.format("DD/MM/YYYY") + " " + moment().format("HH:mm:ss"),
                        "DD/MM/YYYY HH:mm:ss"
                    ).toDate();
                    setQuery({ ...query, [name]: date });
                    getData({ ...query, [name]: date });
                } else {
                    if (e.length === 0) {
                        setQuery({ ...query, [name]: "" });
                        getData({ ...query, [name]: "" });
                    }
                }
            }}
            closeOnSelect={true}
        />
    );
};
